import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Wrench } from "@phosphor-icons/react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
    } catch (_) {
      /* deliberately ignored — response must stay neutral */
    } finally {
      setBusy(false);
      setSent(true);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-12 w-12 bg-blue-600 flex items-center justify-center rounded">
            <Wrench size={28} weight="bold" className="text-white" />
          </div>
          <div>
            <h1 className="font-display text-3xl font-black text-white tracking-tight leading-none">TMIC OPS</h1>
            <p className="font-body text-sm text-slate-400">Operations & Compliance</p>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg border-2 border-slate-300 flex flex-col gap-4" data-testid="forgot-form">
          <h2 className="font-display text-xl font-bold text-slate-900">Forgot password?</h2>
          {sent ? (
            <div className="flex flex-col gap-4">
              <p data-testid="forgot-neutral-message" className="font-body text-sm text-slate-700">
                If an account exists for that email, a password reset link has been sent. Please check your inbox
                (and spam folder) and follow the link to set a new password.
              </p>
              <Link data-testid="forgot-back-login" to="/login" className="text-blue-600 font-semibold text-sm text-center">
                Back to sign in
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="flex flex-col gap-4">
              <p className="font-body text-sm text-slate-600">
                Enter your email and we'll send you a link to reset your password.
              </p>
              <div>
                <label className="font-body text-sm font-semibold text-slate-700">Email</label>
                <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  className="h-12 text-base border-2 mt-1" required autoComplete="email" />
              </div>
              <Button data-testid="forgot-submit" type="submit" disabled={busy || !email}
                className="h-12 text-base font-bold uppercase tracking-wide bg-slate-900 hover:bg-slate-800">
                {busy ? "Sending…" : "Send reset link"}
              </Button>
              <Link data-testid="forgot-cancel" to="/login" className="text-slate-500 font-semibold text-sm text-center">
                Back to sign in
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
